import { BlogsListByBrandDocument } from '@/graphql/__generated/sdk';

import { BlogListResponse } from '@shared-components/components/BlogList/BlogList';
import { getGraphQLClientForContentful } from '@src/lib/graphql/client';
import { logWarning } from '@utils/miscUtils';

export interface GetBlogListByBrandParams {
	limit: number;
	skip: number;
	brandName: string;
	url: string;
	preview: boolean;
	categoryName?: string;
	subCategoryName?: string;
	tags?: Array<string>;
}

export const getBlogListByBrand = async ({
	limit,
	skip,
	brandName,
	url,
	preview,
	categoryName,
	subCategoryName,
	tags,
}: Readonly<GetBlogListByBrandParams>) => {
	try {
		if (!brandName) {
			return {} as BlogListResponse;
		}

		const gqlClient = getGraphQLClientForContentful(url, preview);

		if (gqlClient === null) {
			logWarning('GQL_CLIENT_IS_NULL: missing token for fetching contentful data');
			throw new Error('gqlClient is null');
		}

		const response = await gqlClient
			.query(BlogsListByBrandDocument, {
				limit,
				skip,
				brandName,
				order: ['date_DESC'],
				preview,
				categoryName,
				subCategoryName,
				tags,
			})
			.toPromise();

		return (response.data || {}) as BlogListResponse;
	} catch (err) {
		logWarning('Error fetching blogs list by brand');
		throw err;
	}
};
